import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let Text = class Text extends Vue {};
Text.componentName = 'Text';
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_text_content', '文本区');
  }
})], Text.prototype, "content", void 0);
__decorate([Prop({
  default: 0
})], Text.prototype, "maxLine", void 0);
Text = __decorate([Component({
  name: 'Text'
})], Text);
export default Text;